import {
  InputSelect,
  TextInput,
  DatePickerInput,
  NumberInput,
  RangeDatePickerInput,
  RangeNumberInput,
} from '@wajeez-web/components/ui';
import { SelectedColumnsFilters } from '../types';
import { TFunction } from 'i18next';
export const getFilterComponent = (
  parent: string | number | null,
  i: number,
  handleSelect: (
    parentName: string | number | null,
    type: string
  ) => (name: string, value: any) => void,
  stateOfSelectFilter: SelectedColumnsFilters,
  selectedColumnsFilters: SelectedColumnsFilters[],
  t: TFunction<'translation', undefined>,

  type?: string,
  selectFilter?: any
) => {
  switch (parent ? type : selectFilter.type) {
    case 'String':
      return parent ? (
        <TextInput
          onChange={handleSelect(parent, 'text')}
          placeholder="Search"
          name="value"
          value={
            selectedColumnsFilters.length
              ? typeof selectedColumnsFilters[i].value === 'string'
                ? selectedColumnsFilters[i].value
                : ''
              : ''
          }
        />
      ) : (
        <TextInput
          onChange={handleSelect(null, 'text')}
          placeholder="Search"
          name="value"
          value={
            typeof stateOfSelectFilter.value === 'string'
              ? stateOfSelectFilter.value
              : ''
          }
        />
      );
    case 'select':
      return (
        <InputSelect
          onChange={handleSelect(null, 'select')}
          placeholder="Select Field"
          options={selectFilter.values}
          name="value"
          value={
            typeof stateOfSelectFilter.value !== 'string'
              ? stateOfSelectFilter.value
              : undefined
          }
        />
      );
    case 'Number':
      if (
        stateOfSelectFilter.operator.value === '7' ||
        (selectedColumnsFilters.length &&
          selectedColumnsFilters[i].operator.value === '7')
      ) {
        return parent ? (
          <RangeNumberInput
            onChange={handleSelect(parent, 'number')}
            placeholder="Start number, End number"
            name="value"
            value={
              selectedColumnsFilters.length && selectedColumnsFilters[i].value
            }
          />
        ) : (
          <RangeNumberInput
            onChange={handleSelect(null, 'number')}
            placeholder="Start number, End number"
            name="value"
            value={stateOfSelectFilter.value && stateOfSelectFilter.value}
          />
        );
      } else {
        return parent ? (
          <NumberInput
            onChange={handleSelect(parent, 'number')}
            placeholder="Search"
            name="value"
            value={
              selectedColumnsFilters.length
                ? selectedColumnsFilters[i].value
                  ? Number(selectedColumnsFilters[i].value)
                  : 0
                : 0
            }
          />
        ) : (
          <NumberInput
            onChange={handleSelect(null, 'number')}
            placeholder="Search"
            name="value"
            value={
              stateOfSelectFilter.value ? Number(stateOfSelectFilter.value) : 0
            }
          />
        );
      }
    case 'Boolean':
      return parent ? (
        <InputSelect
          options={[
            { label: t('selects.labels.True', 'True'), value: 'true' },
            { label: t('selects.labels.False', 'False'), value: 'false' },
          ]}
          onChange={handleSelect(parent, 'Boolean')}
          placeholder="Select "
          name="value"
          value={
            selectedColumnsFilters.length
              ? selectedColumnsFilters[i].value === 'true'
                ? { label: 'True', value: 'true' }
                : { label: 'False', value: 'false' }
              : undefined
          }
        />
      ) : (
        <InputSelect
          onChange={handleSelect(null, 'Boolean')}
          placeholder="Select Field"
          options={[
            { label: t('selects.labels.True', 'True'), value: 'true' },
            { label: t('selects.labels.False', 'False'), value: 'false' },
          ]}
          name="value"
          value={
            typeof stateOfSelectFilter.value !== 'string'
              ? stateOfSelectFilter.value
              : undefined
          }
        />
      );

    case 'DateTime':
      if (
        stateOfSelectFilter.operator.value === '7' ||
        (selectedColumnsFilters.length &&
          selectedColumnsFilters[i].operator.value === '7')
      ) {
        return parent ? (
          <RangeDatePickerInput
            onChange={handleSelect(parent, 'DateTime')}
            showTime={true}
            name="value"
            value={
              selectedColumnsFilters.length
                ? typeof selectedColumnsFilters[i].value === 'string'
                  ? selectedColumnsFilters[i].value
                  : undefined
                : undefined
            }
            placeholder="Start date, End date"
          />
        ) : (
          <RangeDatePickerInput
            onChange={handleSelect(null, 'DateTime')}
            showTime={true}
            name="value"
            value={stateOfSelectFilter.value || undefined}
            placeholder="Start date, End date"
          />
        );
      } else {
        return parent ? (
          <DatePickerInput
            onChange={handleSelect(parent, 'DateTime')}
            showTime={true}
            name="value"
            value={
              selectedColumnsFilters.length
                ? typeof selectedColumnsFilters[i].value === 'string'
                  ? selectedColumnsFilters[i].value
                  : undefined
                : undefined
            }
          />
        ) : (
          <DatePickerInput
            onChange={handleSelect(null, 'DateTime')}
            showTime={true}
            name="value"
            value={stateOfSelectFilter.value || undefined}
          />
        );
      }
    case 'Guid':
      return parent ? (
        <TextInput
          onChange={handleSelect(parent, 'Guid')}
          placeholder="Search"
          name="value"
          value={
            selectedColumnsFilters.length
              ? typeof selectedColumnsFilters[i].value === 'string'
                ? selectedColumnsFilters[i].value
                : ''
              : ''
          }
        />
      ) : (
        <TextInput
          onChange={handleSelect(null, 'Guid')}
          placeholder="Search"
          name="value"
          value={
            typeof stateOfSelectFilter.value === 'string'
              ? stateOfSelectFilter.value
              : ''
          }
        />
      );
  }
  return;
};
